import { type APPLICANT_ATTRIBUTION_BOTH_TYPE, INFORMATION_SOURCE } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { LuChevronDown, LuFileSearch, LuHeadset, LuUserCheck } from 'react-icons/lu';

import { cn } from '~/utils/cnTailwind';

const SOURCE_ICONS = {
    [INFORMATION_SOURCE.FORMULAR]: LuUserCheck,
    [INFORMATION_SOURCE.MANUALLY]: LuHeadset,
    [INFORMATION_SOURCE.SCHUFA]: LuFileSearch,
} as const;

type Props = {
    applicant: APPLICANT_ATTRIBUTION_BOTH_TYPE;
    source?: INFORMATION_SOURCE;
    showDetailedView: boolean;
};

export const ApplicantCell = ({ applicant, showDetailedView, source }: Props) => {
    const { t } = useTranslation();
    const SourceIcon = source ? SOURCE_ICONS[source] : null;
    const sourceLabel = t(`EXISTING_LOANS.SOURCES.${source ?? 'UNKNOWN'}`);

    return (
        <>
            <td>
                {SourceIcon && (
                    <SourceIcon className="mx-auto size-4 text-blue" title={sourceLabel} aria-label={sourceLabel} />
                )}
            </td>
            <td>
                <span className="inline-flex items-center gap-1">
                    <LuChevronDown
                        aria-hidden="true"
                        className={cn('size-4 transition-transform', showDetailedView && 'rotate-180')}
                    />
                    {t(`BANK_CREDIT_REQUEST.REFINANCE_PLANNER.${applicant}`)}
                </span>
            </td>
        </>
    );
};
